import i18next from "i18next";
import TodayEdit, { TodayEditProps } from "./TodayEdit";
import TodayResult from "./TodayResult";
import { appMetadataToday } from "src/pods/today";
import { Tool, ToolPayload } from "src/pods/toolkitData/components/EditableSetup";
import EditableToolContainer from "src/pods/toolkitData/components/EditableToolContainer";
import SavedToolButton from "src/pods/toolkitData/components/SavedToolButton";

type TodaySetupContainerProps = {
  params: {
    classId: string;
  };
  onEdit: (tool: ToolPayload, disabled?: boolean) => void;
  payload: ToolPayload;
};

function titleCase(arg: string): string {
  return arg.replace(/(\s|^)([\w])/g, (_m, s, l) => `${s}${l.toLocaleUpperCase()}`);
}

export default function TodaySetupContainer(props: TodaySetupContainerProps) {
  const title = titleCase(
    new Date().toLocaleDateString([i18next.language], {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    }),
  );

  return (
    <EditableToolContainer
      toolType="today"
      title={title}
      appMetadata={appMetadataToday()}
      {...props}
      renderItem={({
        tool,
        openEditScreen,
        showTool,
      }: {
        tool: Tool;
        openEditScreen: (tool: Tool) => void;
        showTool: (tool: Tool) => void;
      }) => (
        <SavedToolButton
          data-name={`today_setup_container:saved_tool_button:${tool._id || tool.dojoId}`}
          key={tool._id || tool.dojoId}
          onRowClick={() => showTool(tool)}
          onEditClick={tool.dojoId ? null : () => openEditScreen(tool)}
        >
          {tool.payload.text}
        </SavedToolButton>
      )}
      renderEditItem={(props: TodayEditProps) => <TodayEdit onEdit={props.onEdit} payload={props.payload} />}
      renderResult={({ tool }: { tool: Tool }) => <TodayResult title={title} text={tool.text} />}
      getDisplayPayload={(tool: Tool) => ({
        type: "RECEIVE_NOTES",
        payload: { title, text: tool.text },
      })}
    />
  );
}
